import request from './index'
export function listType (data={}) {
  return request({
    url: '/portal_component/listType',
    method: "POST",
    data
  })
}
export function articleListPage(data={}) {
  return request({
    url: '/article/listPage',
    method: "POST",
    data
  })
}
// 公告-分页-条件查询
export function noticeListPage(data={}) {
  return request({
    url: '/notice/listPage',
    method: "POST",
    data
  })
}
// 天气
export function getWeather(params={}) {
  return request({
    url: '/external/getWeather',
    method: "GET",
    params
  })
}
// 站点设计详情
export function siteDetailGetSiteDetailDetail (params={}) {
  return request({
    url: '/siteDetail/getSiteDetailDetail',
    method: "GET",
    params
  })
}
//素材中心/文章分类/列表分页
export function listByPageActicleType (data={}) {
  return request({
    url: '/acticleType/listByPage',
    method: "POST",
    data
  })
}
//查询权限文章
export function articleListAuthorityPage (data={}) {
  return request({
    url: '/article/listAuthorityPage',
    method: "POST",
    data
  })
}
// 应用分页模糊查询用户
export function appListPage(data={}) {
  return request({
    url: '/app/listByPage',
    method: "POST",
    data
  })
}
// 栏目树结构
export function siteMenuListSiteMenu(data) {
  return request({
    url: '/siteMenu/listSiteMenu',
    method: "POST",
    data,
  })
}
// 站点栏目详情
export function siteMenuGetBySiteMenuDetail(params) {
  return request({
    url: '/siteMenu/getBySiteMenuDetail',
    method: "GET",
    params,
  })
}
// 查询发布站点的栏目信息
export function releaseSiteMenuTree(params) {
  return request({
    url: '/siteMenu/releaseSiteMenuTree',
    method: "GET",
    params,
  })
}
// 已发布站点栏目详情
export function releaseSiteMenuDetail(params) {
  return request({
    url: '/siteMenu/releaseSiteMenuDetail',
    method: "GET",
    params,
  })
}
// 查询权限公告
export function noticeListAuthorityPage(data) {
  return request({
    url: '/notice/listAuthorityPage',
    method: "POST",
    data,
  })
}
// 查询权限APP
export function appListAuthorityPage(data) {
  return request({
    url: '/app/listAuthorityPage',
    method: "POST",
    data,
  })
}
// 站点列表
export function siteListType (data={}) {
  return request({
    url: '/site/listPage',
    method: "POST",
    data
  })
}
// 新增站点栏目
export function siteMenuAdd(data) {
  return request({
    url: '/siteMenu/add',
    method: "POST",
    data,
  })
}